import React, { Component } from "react";
import { get as _get, map as _map } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";

import { Select, showAlertMessage, CustomModal } from "../../../../resusableComponents/common/formElements";

import { withRouter } from "../../../../resusableComponents/hoc/withRouter";

import Dropzone from "react-dropzone";

import { fetchApifyFilters, initiateApifyLeadSearch, uploadCompanyDomainFile } from "../../../../redux/services/addData";

import { updatePageLevelLoadingState } from "../../../../redux/actions/application";

class LeadScraper extends Component {

  constructor(props) {
    super(props);

    this.state = {
      industryList: [],
      locationList: [],
      emailStatusList: [],
      seniorityLevelList: [],
      companySizeList: [],
      functionalLevelList: [],
      selectedIndustry: [],
      selectedLocation: [],
      selectedEmailStatus: [],
      selectedSeniorityLevel: [],
      selectedCompanySize: [],
      selectedFunctionalLevel: [],
      jobTitle: "",
      leadCount: "",
      searchName: "",
      activeRequestCount: 0,

      // Company Domain file upload
      companyDomainFileName: "",
      companyDomainSheets: [],
      showDomainModal: false,
      selectedDomainSheet: null,
      selectedDomainColumn: null,
      companyDomainValues: [],
    };
  }

  componentDidMount() {
    if (this.props.isActive) {
      this._initialFetch();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isActive && !prevProps.isActive) {
      this._initialFetch();
    }
  }

  _initialFetch = () => {
    this._fetchApifyFilters();
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchApifyFilters = async () => {
    try {
      this._incrementLoader();

      const response = await fetchApifyFilters();

      if ((_get(response, "flag", false)) === true) {
        this.setState({
          industryList: _get(response, "data.industry_list", []),
          locationList: _get(response, "data.location_list", []),
          emailStatusList: _get(response, "data.email_status_list", []),
          seniorityLevelList: _get(response, "data.seniority_level_list", []),
          companySizeList: _get(response, "data.size_list", []),
          functionalLevelList: _get(response, "data.functional_level_list", []),
        });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching filters."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching filters."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleCompanyDomainFileChange = async (acceptedFiles) => {
    const { intl } = this.props;
    const file = (acceptedFiles || [])[0] || null;

    if (!file) { return; }

    try {
      this._incrementLoader();

      const formData = new FormData();
      formData.append("formfile", file);

      const response = await uploadCompanyDomainFile(formData);

      if (_get(response, "flag", false) === true) {
        const sheets = _get(response, "data.sheets", []);

        if (!(sheets || []).length) {
          showAlertMessage(intl.formatMessage({
            id: "addData.leadScraper.no_sheets_found",
            defaultMessage: "No sheets found in the uploaded file."
          }));
          return;
        }

        this.setState({
          companyDomainFileName: (file.name || ""),
          companyDomainSheets: (sheets || []),
          showDomainModal: true,
          selectedDomainSheet: null,
          selectedDomainColumn: null,
        });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while uploading company domain file."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while uploading company domain file."));

    } finally {
      this._decrementLoader();
    }
  }

  _handleDomainModalSubmit = () => {
    const { intl } = this.props;
    const { selectedDomainSheet, selectedDomainColumn } = this.state;

    if (!selectedDomainSheet) {
      showAlertMessage(intl.formatMessage(
        { id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "addData.leadScraper.sheet", defaultMessage: "Worksheet" }) }
      ));
      return;
    }

    if (!selectedDomainColumn) {
      showAlertMessage(intl.formatMessage(
        { id: "error.select_atleast_one", defaultMessage: "Please select at least one {field}." },
        { field: intl.formatMessage({ id: "addData.leadScraper.column", defaultMessage: "Column" }) }
      ));
      return;
    }

    const allValues = (_get(selectedDomainColumn, "col.all_value", []) || []);
    const validDomains = (allValues || []).filter((val) => this._isValidDomain(val));

    if (!(validDomains || []).length) {
      showAlertMessage(intl.formatMessage({
        id: "addData.leadScraper.no_valid_domains",
        defaultMessage: "No valid domains found in the selected column. Please select a column which has a valid domain list.",
      }));
      return;
    }

    this.setState({
      companyDomainValues: validDomains,
      showDomainModal: false,
    });
  }

  _handleDomainModalClose = () => {
    this.setState({ showDomainModal: false });
  }

  _handleRemoveCompanyDomain = () => {
    this.setState({
      companyDomainFileName: "",
      companyDomainSheets: [],
      companyDomainValues: [],
      selectedDomainSheet: null,
      selectedDomainColumn: null,
    });
  }


  // Validates that a value is a proper domain (with or without protocol/www).
  // Rejects bare words like "mydomain" that have no TLD.
  _isValidDomain = (value) => {
    if (!(value || "").trim()) { return false; }
    const domainRegex = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/;
    return domainRegex.test((value || "").trim());
  }

  _handleSubmit = async () => {
    const { intl } = this.props;
    const {
      selectedIndustry, selectedLocation, selectedEmailStatus,
      selectedSeniorityLevel, selectedCompanySize, selectedFunctionalLevel,
      jobTitle, leadCount, searchName, companyDomainValues
    } = this.state;

    const hasAnyFilter = (
      (selectedIndustry || []).length > 0 ||
      (selectedLocation || []).length > 0 ||
      (selectedEmailStatus || []).length > 0 ||
      (selectedSeniorityLevel || []).length > 0 ||
      (selectedCompanySize || []).length > 0 ||
      (selectedFunctionalLevel || []).length > 0 ||
      (jobTitle || "").trim().length > 0 ||
      (companyDomainValues || []).length > 0
    );

    if (!hasAnyFilter) {
      showAlertMessage(intl.formatMessage({
        id: "error.select_atleast_one_filter",
        defaultMessage: "Please select at least one filter."
      }));
      return false;
    }

    if (!(leadCount || "")) {
      showAlertMessage(intl.formatMessage(
        { id: "error.enter", defaultMessage: "Please enter {field}." },
        { field: intl.formatMessage({ id: "addData.leadScraper.lead_count", defaultMessage: "Lead Count" }) }
      ));
      return false;
    }

    if (!(searchName || "")) {
      showAlertMessage(intl.formatMessage(
        { id: "error.enter", defaultMessage: "Please enter {field}." },
        { field: intl.formatMessage({ id: "addData.leadScraper.search_name", defaultMessage: "Search Name" }) }
      ));
      return false;
    }

    const searchFilterJson = JSON.stringify({
      company_industry: _map((selectedIndustry || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      contact_location: _map((selectedLocation || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      contact_job_title: (jobTitle || "").split("\n").map((line) => line.trim().toLowerCase()).filter((line) => line.length > 0),
      email_status: _map((selectedEmailStatus || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      seniority_level: _map((selectedSeniorityLevel || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      size: _map((selectedCompanySize || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      functional_level: _map((selectedFunctionalLevel || []), (item) => ((_get(item, "item_name", null) || "").toLowerCase() || null)),
      company_domain: (companyDomainValues || []).filter((val) => this._isValidDomain(val))
    });

    const payload = {
      lead_count: (parseInt(leadCount, 10) || 0),
      search_name: (searchName || ""),
      search_filter_json: (searchFilterJson || "")
    };

    try {
      this._incrementLoader();
      const response = await initiateApifyLeadSearch(payload);

      if ((_get(response, "flag", false)) === true) {
        showAlertMessage(
          _get(response, "message", intl.formatMessage({ id: "success.lead_search_initiated", defaultMessage: "Lead search initiated successfully." })),
          "success"
        );
        this.setState({
          selectedIndustry: [],
          selectedLocation: [],
          selectedEmailStatus: [],
          selectedSeniorityLevel: [],
          selectedCompanySize: [],
          selectedFunctionalLevel: [],
          jobTitle: "",
          leadCount: "",
          searchName: "",
          companyDomainFileName: "",
          companyDomainValues: [],
        });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while initiating apify lead search."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while initiating apify lead search."));

    } finally {
      this._decrementLoader();
    }
  }

  _renderMultiSelect = (options, value, onChange, labelId, labelDefault) => {
    const { intl } = this.props;
    return (
      <Select
        options={(options || [])}
        getOptionLabel={(option) => (_get(option, "item_name", "") || "")}
        getOptionValue={(option) => (_get(option, "item_name", "") || "")}
        placeholder={intl.formatMessage(
          { id: "placeholder.select_field", defaultMessage: "Select {field}" },
          { field: intl.formatMessage({ id: labelId, defaultMessage: labelDefault }) }
        )}
        label={intl.formatMessage({ id: labelId, defaultMessage: labelDefault })}
        value={(value || [])}
        onChange={(val) => onChange(val || [])}
        isMulti={true}
      />
    );
  }

  _renderCompanyDomainModal = () => {
    const { intl } = this.props;
    const { showDomainModal, companyDomainSheets, selectedDomainSheet, selectedDomainColumn } = this.state;

    if (!showDomainModal) { return null; }

    const sheetOptions = (companyDomainSheets || []).map((sheet) => ({
      label: (_get(sheet, "name", "") || ""),
      value: (_get(sheet, "name", "") || ""),
      sheet,
    }));

    const columnOptions = selectedDomainSheet
      ? (_get(selectedDomainSheet, "sheet.columns", []) || []).map((col) => ({
        label: (_get(col, "name", "") || ""),
        value: (_get(col, "name", "") || ""),
        col,
      }))
      : [];

    const topValues = selectedDomainColumn
      ? (_get(selectedDomainColumn, "col.top_value", []) || [])
      : [];

    return (
      <CustomModal
        size="md"
        isOpen={showDomainModal}
        centered={true}
        modalTitle={intl.formatMessage({ id: "addData.leadScraper.select_domain_column", defaultMessage: "Select Company Domain Column" })}
        onHide={this._handleDomainModalClose}
        onClose={this._handleDomainModalClose}
      >
        <>
          <div className="row gy-3">

            <div className="col-lg-12">
              <label className="form-label text-capitalize">
                <FormattedMessage id="addData.leadScraper.select_sheet" defaultMessage="Select Worksheet" />
              </label>
              <Select
                options={(sheetOptions || [])}
                getOptionLabel={(option) => (_get(option, "label", "") || "")}
                getOptionValue={(option) => (_get(option, "value", "") || "")}
                placeholder={intl.formatMessage(
                  { id: "placeholder.select_field", defaultMessage: "Select {field}" },
                  { field: intl.formatMessage({ id: "addData.leadScraper.sheet", defaultMessage: "Worksheet" }) }
                )}
                value={(selectedDomainSheet || null)}
                onChange={(val) => this.setState({ selectedDomainSheet: (val || null), selectedDomainColumn: null })}
                isMulti={false}
              />
            </div>

            {(selectedDomainSheet) && (
              <div className="col-lg-12">
                <label className="form-label text-capitalize">
                  <FormattedMessage id="addData.leadScraper.select_column" defaultMessage="Select Column" />
                </label>
                <Select
                  options={(columnOptions || [])}
                  getOptionLabel={(option) => (_get(option, "label", "") || "")}
                  getOptionValue={(option) => (_get(option, "value", "") || "")}
                  placeholder={intl.formatMessage(
                    { id: "placeholder.select_field", defaultMessage: "Select {field}" },
                    { field: intl.formatMessage({ id: "addData.leadScraper.column", defaultMessage: "Column" }) }
                  )}
                  value={(selectedDomainColumn || null)}
                  onChange={(val) => this.setState({ selectedDomainColumn: (val || null) })}
                  isMulti={false}
                />
              </div>
            )}

            {(selectedDomainColumn && (topValues || []).length > 0) && (
              <div className="col-lg-12">
                <label className="form-label fw-bold text-capitalize">
                  <FormattedMessage id="addData.leadScraper.preview_values" defaultMessage="Preview (top values)" />
                </label>
                {(topValues || []).map((val, idx) => (
                  <div key={idx} className="border p-2">
                    <span>{(val || "")}</span>
                  </div>
                ))}
              </div>
            )}

          </div>

          <div className="pt-4 px-4 mx-n4 mt-3 d-flex gap-3 align-items-center justify-content-end border-top">
            <button
              className="btn btn-primary waves-effect text-capitalize"
              onClick={() => this._handleDomainModalSubmit()}
            >
              <FormattedMessage id="btn.submit" defaultMessage="submit" />
            </button>
            <button
              className="btn btn-dark waves-effect text-capitalize"
              onClick={() => this._handleDomainModalClose()}
            >
              <FormattedMessage id="btn.cancel" defaultMessage="cancel" />
            </button>
          </div>
        </>
      </CustomModal>
    );
  }

  render() {
    const { intl, allowedDataUploadFiles, allowedDataUploadFilesLabel } = this.props;
    const {
      industryList, locationList, emailStatusList, seniorityLevelList, companySizeList, functionalLevelList,
      selectedIndustry, selectedLocation, selectedEmailStatus, selectedSeniorityLevel, selectedCompanySize, selectedFunctionalLevel,
      jobTitle, leadCount, searchName,
      companyDomainFileName, companyDomainValues,
    } = this.state;

    return (
      <div className="row gy-4 mt-0">
        <div className="col-lg-12">

          <div className="row gy-3">

            <div className="col-lg-3">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="addData.leadScraper.search_name" defaultMessage="Search Name" />
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={intl.formatMessage(
                    { id: "placeholder.enter_field", defaultMessage: "Enter {field}" },
                    { field: intl.formatMessage({ id: "addData.leadScraper.search_name", defaultMessage: "Search Name" }) }
                  )}
                  value={(searchName || "")}
                  onChange={(e) => this.setState({ searchName: (e.target.value || "") })}
                />
              </div>
            </div>

            <div className="col-lg-3">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="addData.leadScraper.lead_count" defaultMessage="Lead Count" />
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder={intl.formatMessage(
                    { id: "placeholder.enter_field", defaultMessage: "Enter {field}" },
                    { field: intl.formatMessage({ id: "addData.leadScraper.lead_count", defaultMessage: "Lead Count" }) }
                  )}
                  value={(leadCount || "")}
                  onChange={(e) => this.setState({ leadCount: (e.target.value || "") })}
                />
              </div>
            </div>

            <div className="col-lg-3">
              <Select
                options={(industryList || [])}
                getOptionLabel={(option) => (_get(option, "item_name", "") || "")}
                getOptionValue={(option) => (_get(option, "item_name", "") || "")}
                placeholder={intl.formatMessage(
                  { id: "placeholder.select_field", defaultMessage: "Select {field}" },
                  { field: intl.formatMessage({ id: "addData.leadScraper.industry", defaultMessage: "Industry" }) }
                )}
                label={intl.formatMessage({ id: "addData.leadScraper.industry", defaultMessage: "Industry" })}
                value={(selectedIndustry || [])}
                onChange={(value) => this.setState({ selectedIndustry: (value || []) })}
                isMulti={true}
              />
            </div>

            <div className="col-lg-3">
              <Select
                options={(locationList || [])}
                getOptionLabel={(option) => (_get(option, "item_name", "") || "")}
                getOptionValue={(option) => (_get(option, "item_name", "") || "")}
                placeholder={intl.formatMessage(
                  { id: "placeholder.select_field", defaultMessage: "Select {field}" },
                  { field: intl.formatMessage({ id: "addData.leadScraper.location", defaultMessage: "Location" }) }
                )}
                label={intl.formatMessage({ id: "addData.leadScraper.location", defaultMessage: "Location" })}
                value={(selectedLocation || [])}
                onChange={(value) => this.setState({ selectedLocation: (value || []) })}
                isMulti={true}
              />
            </div>

          </div>

          <div className="row gy-3 mt-0">

            <div className="col-lg-3">
              {this._renderMultiSelect(
                emailStatusList,
                selectedEmailStatus,
                (val) => this.setState({ selectedEmailStatus: val }),
                "addData.leadScraper.email_status",
                "Email Status"
              )}
            </div>

            <div className="col-lg-3">
              {this._renderMultiSelect(
                seniorityLevelList,
                selectedSeniorityLevel,
                (val) => this.setState({ selectedSeniorityLevel: val }),
                "addData.leadScraper.seniority_level",
                "Seniority Level"
              )}
            </div>

            <div className="col-lg-3">
              {this._renderMultiSelect(
                companySizeList,
                selectedCompanySize,
                (val) => this.setState({ selectedCompanySize: val }),
                "addData.leadScraper.company_size",
                "Company Size"
              )}
            </div>

            <div className="col-lg-3">
              {this._renderMultiSelect(
                functionalLevelList,
                selectedFunctionalLevel,
                (val) => this.setState({ selectedFunctionalLevel: val }),
                "addData.leadScraper.functional_level",
                "Functional Level"
              )}
            </div>

          </div>

          <div className="row gy-3 mt-0">

            <div className="col-lg-6">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="addData.leadScraper.job_title" defaultMessage="Job Title" />
                </label>
                <textarea
                  className="form-control"
                  rows={9}
                  placeholder={intl.formatMessage(
                    { id: "placeholder.enter_field", defaultMessage: "Enter {field}" },
                    { field: intl.formatMessage({ id: "addData.leadScraper.job_title", defaultMessage: "Job Title" }) }
                  )}
                  value={(jobTitle || "")}
                  onChange={(e) => this.setState({ jobTitle: (e.target.value || "") })}
                />
                <small className="mt-1 text-grey-93 small">
                  <FormattedMessage id="addData.leadScraper.job_title_note" defaultMessage="Enter each value on a new line." />
                </small>
              </div>
            </div>
            <div className="col-lg-6">
              <div>
                <label className="form-label text-capitalize">
                  <FormattedMessage id="addData.leadScraper.company_domain" defaultMessage="Company Domain" />
                </label>

                {!(companyDomainFileName) && (
                  <Dropzone
                    maxFiles={1}
                    multiple={false}
                    accept={(allowedDataUploadFiles || undefined)}
                    onDrop={(acceptedFiles) => this._handleCompanyDomainFileChange(acceptedFiles)}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="mb-0" {...getRootProps({ className: "dropzone" })}>
                        <div className="file-upload mt-0">
                          <input {...getInputProps()} />
                          <img
                            src={require("../../../../assets/icons/icon-upload.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                          <p>
                            <FormattedMessage id="file.drop_file_here_or_click_to_upload" defaultMessage="Drop files here or click to upload" />
                          </p>
                        </div>
                      </div>
                    )}
                  </Dropzone>
                )}

                {(companyDomainFileName) && (
                  <div className="file-upload-inline-list mt-2">
                    <p className="mb-0">
                      {(companyDomainFileName || "")}
                      {((companyDomainValues || []).length > 0) && (
                        <span className="ms-2 badge bg-success">
                          {(companyDomainValues || []).length}
                          {" "}
                          <FormattedMessage id="addData.leadScraper.domains_loaded" defaultMessage="domains loaded" />
                        </span>
                      )}
                    </p>
                    <button
                      className="btn btn-dark btn-sm waves-effect"
                      type="button"
                      onClick={() => this._handleRemoveCompanyDomain()}
                    >
                      <FormattedMessage id="btn.delete" defaultMessage="delete" />
                    </button>
                  </div>
                )}

                {(allowedDataUploadFilesLabel) && (
                  <label className="mt-1 text-grey-93 small">
                    <FormattedMessage
                      id="file.allowed_files"
                      defaultMessage="Allowed file extensions : {allowedExtensions}"
                      values={{ allowedExtensions: (allowedDataUploadFilesLabel || "") }}
                    />
                  </label>
                )}
              </div>
            </div>

          </div>

        </div>

        {/* Submit row */}
        <div className="row gy-3 mt-0">
          <div className="col-lg-12 d-flex justify-content-end align-items-end">
            <button
              type="button"
              className="btn btn-primary waves-effect text-capitalize"
              onClick={() => this._handleSubmit()}
            >
              <FormattedMessage id="btn.submit" defaultMessage="submit" />
            </button>
          </div>
        </div>

        {this._renderCompanyDomainModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedDataUploadFiles: _get(state, "application.constants.allowedDataUploadFiles", ""),
  allowedDataUploadFilesLabel: _get(state, "application.constants.allowedDataUploadFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(LeadScraper)));
